import { BalanceCategory } from "@/domains/wallet";
// components
import { Spin } from "antd";
import { ThunderboltFilled, LoadingOutlined } from "@ant-design/icons";

interface BalanceChipProps {
  amount: string;
  loading: boolean;
  currency: string;
  category: BalanceCategory;
}

const currencyConfig = {
  USDT_0: {
    fg: "#009393",
    bg: "#cce9e9",
    label: "USDT",
    logo: "/usdt.png",
  },
  USDT_1: {
    fg: "#009393",
    bg: "#cce9e9",
    label: "USDT",
    logo: "/usdt.png",
  },
  TRX_0: {
    fg: "#d82627",
    bg: "#ffc2c2",
    label: "TRX",
    logo: "/trx.png",
  },
  TRX_1: {
    fg: "#d82627",
    bg: "#ffc2c2",
    label: "TRX",
    logo: "/trx.png",
  },
};

export const BalanceChip = ({
  loading,
  amount,
  currency,
  category,
}: BalanceChipProps) => {
  const config =
    currencyConfig[`${currency}_${category}` as keyof typeof currencyConfig];

  return (
    <div
      className={`h:28 px:12 flex ai:center gap:8 bg:${config.bg} rounded user-select:none`}
    >
      {loading ? (
        <Spin
          indicator={<LoadingOutlined spin className="f:12! ml:3 mr:3" />}
        />
      ) : (
        <img src={config.logo} alt={currency} className="w:18" />
      )}
      <span className={`fg:${config.fg}`}>
        <span className="mr:4">{config.label}:</span>
        {
          <>
            {parseFloat(amount).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            {category === BalanceCategory.OfficialInstant && (
              <ThunderboltFilled className="ml:4 f:12!" />
            )}
          </>
        }
      </span>
    </div>
  );
};
